/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchHistoryParams,
  GetPouchListResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get Pouch history list for a branch
 * @summary Get Pouch history list for a branch
 */
export const getPouchHistory = (params?: GetPouchHistoryParams, signal?: AbortSignal) => {
  return customInstance<GetPouchListResponseResponse>({
    url: `/bm-pouch-management/v1/pouch/history`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetPouchHistoryQueryKey = (params?: GetPouchHistoryParams) => {
  return [`/bm-pouch-management/v1/pouch/history`, ...(params ? [params] : [])] as const;
};

export const getGetPouchHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchHistory>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchHistory>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchHistory>>> = ({ signal }) =>
    getPouchHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getPouchHistory>>>;
export type GetPouchHistoryQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get Pouch history list for a branch
 */
export const useGetPouchHistory = <
  TData = Awaited<ReturnType<typeof getPouchHistory>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchHistory>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
